module.exports = __webpack_public_path__ + "img/logo.2f365fb1.png";